import React, { useEffect, useState } from "react";
import { callAPIWithoutAuth } from "../utils/apiUtils";
import { apiUrls } from "../utils/apiUrls";
import { useLanguage } from "../context/LanguageContext";
import { ErrorMessage, SuccessMessage } from "../helpers/Index";
import { translations } from "../languages";

export default function EventEnquiry({ eventtype,eventname }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    restaurant_id: "",
    name: "",
    phone: "",
    date: "",
    time: "",
    no_of_guest: 1,
    speacial_instruction: "",
  });
  const Restaurantlisting = async () => {
    try {
      const apiResponse = await callAPIWithoutAuth(
        apiUrls.restaurantlisting,
        {},
        "GET",
        {},
      );

      if (apiResponse?.data?.success) {
        setData(apiResponse?.data?.data || []);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
    } finally {
    }
  };

  useEffect(() => {
    Restaurantlisting();

    // eslint-disable-next-line
  }, [eventtype]);
  const { language } = useLanguage();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const increaseGuest = () => {
    setFormData({
      ...formData,
      no_of_guest: formData.no_of_guest + 1,
    });
  };

  const decreaseGuest = () => {
    if (formData.no_of_guest > 1) {
      setFormData({
        ...formData,
        no_of_guest: formData.no_of_guest - 1,
      });
    }
  };

  const submitEnquiry = async () => {
    try {
      const payload = {
        event_id: eventtype,
        restaurant_id: formData.restaurant_id,
        name: formData.name,
        phone: formData.phone,
        date: formData.date,
        time: formData.time,
        no_of_guest: formData.no_of_guest,
        speacial_instruction: formData.speacial_instruction,
      };
      setLoading(true);
      const apiResponse = await callAPIWithoutAuth(
        apiUrls.eventenquiry,
        {},
        "POST",
        payload,
      );
      setLoading(false);
      if (apiResponse?.data?.success) {
        SuccessMessage(apiResponse?.data?.message);
        // reset form
        setFormData({
          restaurant_id: "",
          name: "",
          phone: "",
          date: "",
          time: "",
          no_of_guest: 1,
          speacial_instruction: "",
        });
        // close modal
        const modal = document.getElementById("EventEnquiryModal");
        const modalInstance = window.bootstrap.Modal.getInstance(modal);
        modalInstance.hide();
      } else {
        ErrorMessage(apiResponse?.data?.message);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
     const t = translations[language];
  return (
    <div
      className="modal fade"
      id="EventEnquiryModal"
      tabIndex={-1}
      aria-labelledby="eventEnquiryModalTitle"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <button
              type="button"
              className="btn-close close_bg"
              data-bs-dismiss="modal"
              aria-label={language === "en" ? "Close" : "閉じる"}
            >
              <img src="/image/simple-cross.svg" className="img-fluid" alt="" />
            </button>
            <div className="add-detail mt-2">
              <h3 className="font--18" id="eventEnquiryModalTitle">{t.EventEnquiryContent.heading} {eventname && (
    <span className="badge bg-light text-dark border fw-normal">
      🎉 {eventname}
    </span>
  )}</h3>
              <p className="font--14">
               {t.EventEnquiryContent.description}
              </p>
            </div>
           
            <div className="choose-option category-accordian mt-4">
              <label  className="font--15 mb-2" htmlFor="event-restaurant">{t.EventEnquiryContent.restaurantLabel}</label>
              <select
                className="form-select"
                id="event-restaurant"
                name="restaurant_id"
                value={formData.restaurant_id}
                onChange={handleChange}
              >
                <option value={""}>{t.EventEnquiryContent.selectRestaurant}</option>
                {data?.map((val, i) => (
                  <option key={i} value={val.id}>
                    {language === "en" ? val?.en_name : val?.ja_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="choose-option category-accordian mt-3">
              <div className="row">
                <div className="col-lg-6">
                  <label htmlFor="event-name" className="font--15 mb-2">
                    {t.EventEnquiryContent.nameLabel} <sub>*</sub>
                  </label>
                  <div className="position-relative table_date">
                    <input
                      type="text"
                      id="event-name"
                      className="form-control"
                      placeholder={t.EventEnquiryContent.namePlaceholder}
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <label htmlFor="event-phone" className="font--15 mb-2">
                    {t.EventEnquiryContent.phoneLabel} <sub>*</sub>
                  </label>
                  <div className="position-relative table_date">
                    <input
                      type="text"
                      id="event-phone"
                      className="form-control"
                      placeholder={t.EventEnquiryContent.phonePlaceholder}
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-lg-6 mt-3">
                  <label htmlFor="event-date" className="font--15 mb-2">
                    {t.EventEnquiryContent.selectDateLabel} <sub>*</sub>
                  </label>
                  <div className="position-relative table_date">
                    <input
                      type="date"
                      id="event-date"
                      className="form-control"
                      placeholder="Pick a date"
                      name="date"
                      value={formData.date}
                      onChange={handleChange}
                    />
                    <img src="/image/calendar.svg" alt="" />
                  </div>
                </div>
                <div className="col-lg-6 mt-3">
                  <label className="font--15 mb-2" htmlFor="event-time">
                    {t.EventEnquiryContent.selectTimeLabel} <sub>*</sub>
                  </label>
                  <div className="position-relative table_date">
                    <input
                    id="event-time"
                      type="time"
                      className="form-control"
                     placeholder="Pick a time"
                      name="time"
                      value={formData.time}
                      onChange={handleChange}
                    />
                    <img src="/image/time-circle.svg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div className="choose-option category-accordian mt-3">
              <h5 className="font--15 mb-2" id="guest-count-label">
                {t.EventEnquiryContent.numberOfGuestLabel} <sub>*</sub>
              </h5>
              <div className="qty-box d-flex align-items-center justify-content-between border px-3"  role="group"
  aria-labelledby="guest-count-label">
                <button
                type="button"
                  className="btn btn-light border-0 pe-0 ps-0"
                  onClick={decreaseGuest}
                   aria-label={language === "en" ? "Decrease guests" : "人数を減らす"}
                >
                  <img src="/image/minus-circle.svg" alt="" />
                </button>
                <span className="font--15">{formData.no_of_guest}</span>
                <button
                type="button"
                  className="btn btn-light border-0 pe-0 ps-0"
                  onClick={increaseGuest}
                   aria-label={language === "en" ? "Increase guests" : "人数を増やす"}
                >
                  <img src="/image/plus-circle.svg" alt="" />
                </button>
              </div>
            </div>
            <div className="choose-option category-accordian mt-3">
              <label htmlFor="event-special-instruction" className="font--15 mb-2"> {t.EventEnquiryContent.specialRequestsLabel}</label>
              <textarea
                className="form-control"
                id="event-special-instruction"
                rows="2"
                placeholder={t.EventEnquiryContent.specialRequestsPlaceholder}
                name="speacial_instruction"
                value={formData.speacial_instruction}
                onChange={handleChange}
              ></textarea>
            </div>
            <button
            type="button"
              className="btn primary-btn w-100 mt-4"
              onClick={submitEnquiry}
              disabled={loading}
            >
              {loading ? t.EventEnquiryContent.submitting : t.EventEnquiryContent.submitEnquiry}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
